import { render, staticRenderFns } from "./SearchParcel.vue?vue&type=template&id=52c3aea5&"
import script from "./SearchParcel.vue?vue&type=script&lang=js&"
export * from "./SearchParcel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports